<template>
  <div>
    <load v-if="loading"
          message="Carregando informações do usuário"/>
    <div class="row"
         v-else>
      <div class="col-md-12">
        <div class="d-block card shadow p-6">
          <h2>Selecione quais abas deseja imprimir</h2>

          <form-select
              v-model="abasSelecionadas"
              grid="12"
              label="Selecione as abas"
              :itens="listAbas"
              multiple
          />

          <div class="col-md-12">
            <button
                class="btn btn-default"
                data-style="zoom-in"
                type="button"
                @click.prevent="clearAllTabs"
            >
              {{ $t("Limpar") }}
            </button>
            <button
                class="btn btn-success"
                data-style="zoom-in"
                type="button"
                @click.prevent="allTabs"
            >
              {{ $t("Selecionar Todos") }}
            </button>

            <b-button
                :title="$t('Visualizar e Imprimir')"
                class="py-2"
                size="sm"
                type="button"
                v-b-tooltip.hover
                variant="primary"
                @click="print"
            >
              <i class="fas fa-print"></i>
              Imprimir
            </b-button>
          </div>

        </div>
      </div>

      <div class="col-md-12">
        <print-content>
          <div class="table-responsive">
            <Identificacao
                :usuario="usuario.identificacao"
                v-if="verificarAba('IDENTIFICAÇÃO')"
            />
            <Documento
                :usuario="usuario.documentos"
                v-if="usuario.hasOwnProperty('documentos') && verificarAba('DOCUMENTOS')"
            />
            <Escolaridade
                :usuario="usuario.escolaridade"
                v-if="usuario.hasOwnProperty('escolaridade') && verificarAba('ESCOLARIDADE')"
            />
            <Saude
                :usuario="usuario.saude"
                :cartaoSus="usuario.documentos.cartao_sus"
                v-if="usuario.hasOwnProperty('saude') && verificarAba('SAÚDE')"
            />
            <Renda
                :usuario="usuario.remuneracao"
                v-if="
              usuario.hasOwnProperty('remuneracao') &&
              verificarAba('TRABALHO E REMUNERAÇÃO')
            "
            />
            <SituacaoRua
                :usuario="usuario.situacaorua"
                v-if="
              usuario.hasOwnProperty('situacaorua') && verificarAba('SITUAÇÃO DE RUA')
            "
            />
            <Aspecto
                :usuario="usuario.aspecto"
                v-if="
              usuario.hasOwnProperty('aspecto') &&
              verificarAba('ASPECTOS E SITUAÇÃO FAMILIAR')
            "
            />
            <Lazer
                :usuario="usuario.lazer"
                v-if="
              usuario.hasOwnProperty('lazer') && verificarAba('LAZER CULTURA E ESPORTE')
            "
            />

            <!-- Dados da Família -->
            <IdentificacaoFamilia
                v-if="abasfamilia && verificarAba('FAMÍLIA: IDENTIFICAÇÃO')"
                :item="abasfamilia"
                :loading="loadingFamilia"
            />

            <!-- Composição Familiar -->
            <ComposicaoFamiliar
                v-if="abasfamilia && abasfamilia.familiares  && verificarAba('FAMÍLIA: COMPOSIÇÃO')"
                :item="abasfamilia"
                :loading="loadingFamilia"
            />

            <!-- Condições Habitacionais -->
            <Habitacao v-if="abasfamilia  && verificarAba('FAMÍLIA: HABITAÇÃO')"
                       :item="abasfamilia"
                       :loading="loadingFamilia"/>

            <!-- Condições Educacional -->
            <Educacional v-if="abasfamilia  && verificarAba('FAMÍLIA: EDUCAÇÃO')"
                         :item="abasfamilia"
                         :loading="loadingFamilia"/>

            <!-- Condições Financeira -->
            <Financeiro v-if="abasfamilia  && verificarAba('FAMÍLIA: FINANCEIRO')"
                        :item="abasfamilia"
                        :loading="loadingFamilia"/>

            <!-- Condições Saúde -->
            <SaudeFamilia
                v-if="abasfamilia && abasfamilia.familiares  && verificarAba('FAMÍLIA: SAÚDE')"
                :item="abasfamilia"
                :loading="loadingFamilia"
            />

            <!-- Outras Características -->
            <CaracteristicaFamilia
                v-if="abasfamilia  && verificarAba('FAMÍLIA: CARACTERÍSTICAS')"
                :item="abasfamilia"
                :loading="loadingFamilia"
            />
            <!-- Convivência Familiar e Comunitária -->
            <ConvivenciaFamilia
                v-if="abasfamilia  && verificarAba('FAMÍLIA: CONVIVÊNCIA')"
                :item="abasfamilia"
                :loading="loadingFamilia"
            />

            <!-- Serviços e Intervenções -->
            <HistoricoScfv
                :items="usuario.inscricoesScfv"
                v-if="
              usuario.hasOwnProperty('inscricoesScfv') && verificarAba('SCFV HISTÓRICO')
            "
            />

            <!-- Atendimentos -->
            <Atendimentos :familia="abasfamilia.id"
                          v-if="abasfamilia && verificarAba('SERVIÇOS/INTERVENÇÕES: ATENDIMENTOS')"/>
            <!-- Encaminhamentos -->
            <Encaminhamentos :familia="abasfamilia.id"
                             v-if="abasfamilia && verificarAba('SERVIÇOS/INTERVENÇÕES: ENCAMINHAMENTOS')"/>

            <!-- Acompanhamentos -->
            <Acompanhamentos :familia="abasfamilia.id"
                             v-if="abasfamilia && verificarAba('SERVIÇOS/INTERVENÇÕES: ACOMPANHAMENTOS')"/>

            <!-- Benefícios -->
            <Beneficios :familia="abasfamilia.id"
                        v-if="abasfamilia && verificarAba('SERVIÇOS/INTERVENÇÕES: BENEFÍCIOS')"/>

            <!-- Violações -->
            <Violacoes :familia="abasfamilia.id"
                       v-if="abasfamilia && verificarAba('SERVIÇOS/INTERVENÇÕES: VIOLAÇÕES DE DIREITOS')"/>

            <Programas :familia="abasfamilia.id"
                       v-if="abasfamilia && verificarAba('SERVIÇOS/INTERVENÇÕES: PROGRAMAS SOCIAIS')"/>


            <AcolhimentoCriancas :familia="abasfamilia.id"
                                 v-if="abasfamilia && verificarAba('SERVIÇOS/INTERVENÇÕES: ACOLHIMENTOS')"/>

            <Medidas :familia="abasfamilia.id"
                     v-if="abasfamilia && verificarAba('SERVIÇOS/INTERVENÇÕES: MEDIDAS SOCIOEDUCATIVAS')"/>

            <!-- Atividades -->
            <Atividades
                :usuario="$route.params.id"
                v-if="verificarAba('SERVIÇOS/INTERVENÇÕES: ATIVIDADES')"
            />

          </div>
          <!-- Acompanhamentos -->
        </print-content>
      </div>

    </div>
  </div>
</template>
<script>
import Identificacao from "./includes/impressao/Identificacao";
import Documento from "./includes/impressao/Documento";
import Escolaridade from "./includes/impressao/Escolaridade";
import Saude from "./includes/impressao/Saude";
import Renda from "./includes/impressao/Renda";
import SituacaoRua from "./includes/impressao/SituacaoRua";
import Aspecto from "./includes/impressao/Aspecto";
import Lazer from "./includes/impressao/Lazer";

import IdentificacaoFamilia from "./includes/impressao/familia/Identificacao";
import ComposicaoFamiliar from "./includes/impressao/familia/Composicao";
import Habitacao from "./includes/impressao/familia/Habitacao";
import Educacional from "./includes/impressao/familia/Educacional";
import Financeiro from "./includes/impressao/familia/Financeiro";
import SaudeFamilia from "./includes/impressao/familia/Saude";
import CaracteristicaFamilia from "./includes/impressao/familia/Caracteristica";
import ConvivenciaFamilia from "./includes/impressao/familia/Convivencia";

import HistoricoScfv from "./includes/impressao/HistoricoScfv";
import Atendimentos from "./includes/impressao/atendimentos/Atendimentos.vue";

import Atividades from "./includes/impressao/atividades/Atividades.vue";

import Encaminhamentos from "./includes/impressao/encaminhamentos/Encaminhamentos.vue";

import Acompanhamentos from "./includes/impressao/acompanhamentos/Acompanhamentos.vue";

import Beneficios from "./includes/impressao/beneficios/Beneficios.vue";

import Violacoes from "./includes/impressao/violacoes/Violacoes.vue";

import Programas from "./includes/impressao/programas/Programas.vue";

import AcolhimentoCriancas from "./includes/impressao/acolhimentos/Acolhimentos.vue";

import Medidas from "./includes/impressao/medidas/Medidas.vue";


export default {
  name: "ImprimirUsuario",
  data() {
    return {
      loading: true,
      usuario: null,
      identificacao: true,
      documentos: null,
      escolaridade: null,
      remuneracao: null,
      situacaoRua: null,
      aspecto: null,
      lazer: null,
      abasfamilia: null,
      loadingFamilia: true,
      abasSelecionadas: ["IDENTIFICAÇÃO"],
      listAbas: [
        {id: "IDENTIFICAÇÃO", value: "IDENTIFICAÇÃO"},
        {id: "DOCUMENTOS", value: "DOCUMENTOS"},
        {id: "ESCOLARIDADE", value: "ESCOLARIDADE"},
        {id: "SAÚDE", value: "SAÚDE"},
        {id: "TRABALHO E REMUNERAÇÃO", value: "TRABALHO E REMUNERAÇÃO"},
        {id: "SITUAÇÃO DE RUA", value: "SITUAÇÃO DE RUA"},
        {id: "ASPECTOS E SITUAÇÃO FAMILIAR", value: "ASPECTOS E SITUAÇÃO FAMILIAR"},
        {id: "LAZER CULTURA E ESPORTE", value: "LAZER CULTURA E ESPORTE"},
        {id: "SCFV HISTÓRICO", value: "SCFV HISTÓRICO"},
        {id: "FAMÍLIA: IDENTIFICAÇÃO", value: "FAMÍLIA: IDENTIFICAÇÃO"},
        {id: "FAMÍLIA: COMPOSIÇÃO", value: "FAMÍLIA: COMPOSIÇÃO"},
        {id: "FAMÍLIA: HABITAÇÃO", value: "FAMÍLIA: HABITAÇÃO"},
        {id: "FAMÍLIA: EDUCAÇÃO", value: "FAMÍLIA: EDUCAÇÃO"},
        {id: "FAMÍLIA: FINANCEIRO", value: "FAMÍLIA: FINANCEIRO"},
        {id: "FAMÍLIA: SAÚDE", value: "FAMÍLIA: SAÚDE"},
        {id: "FAMÍLIA: CARACTERÍSTICAS", value: "FAMÍLIA: CARACTERÍSTICAS"},
        {id: "FAMÍLIA: CONVIVÊNCIA", value: "FAMÍLIA: CONVIVÊNCIA"},
        {id: "SERVIÇOS/INTERVENÇÕES: ATENDIMENTOS", value: "SERVIÇOS/INTERVENÇÕES: ATENDIMENTOS"},
        {id: "SERVIÇOS/INTERVENÇÕES: ATIVIDADES", value: "SERVIÇOS/INTERVENÇÕES: ATIVIDADES"},
        {id: "SERVIÇOS/INTERVENÇÕES: ENCAMINHAMENTOS", value: "SERVIÇOS/INTERVENÇÕES: ENCAMINHAMENTOS"},
        {id: "SERVIÇOS/INTERVENÇÕES: ACOMPANHAMENTOS", value: "SERVIÇOS/INTERVENÇÕES: ACOMPANHAMENTOS"},
        {id: "SERVIÇOS/INTERVENÇÕES: BENEFÍCIOS", value: "SERVIÇOS/INTERVENÇÕES: BENEFÍCIOS"},
        {id: "SERVIÇOS/INTERVENÇÕES: VIOLAÇÕES DE DIREITOS", value: "SERVIÇOS/INTERVENÇÕES: VIOLAÇÕES DE DIREITOS"},
        {id: "SERVIÇOS/INTERVENÇÕES: PROGRAMAS SOCIAIS", value: "SERVIÇOS/INTERVENÇÕES: PROGRAMAS SOCIAIS"},
        {id: "SERVIÇOS/INTERVENÇÕES: ACOLHIMENTOS", value: "SERVIÇOS/INTERVENÇÕES: ACOLHIMENTOS"},
        {id: "SERVIÇOS/INTERVENÇÕES: MEDIDAS SOCIOEDUCATIVAS", value: "SERVIÇOS/INTERVENÇÕES: MEDIDAS SOCIOEDUCATIVAS"},
      ],
    };
  },
  mounted() {
    this.getUsuario();
    this.getAbasFamilias();
  },
  methods: {
    allTabs() {
      this.abasSelecionadas = this.listAbas.map((el) => (
          el.id
      ));
    },
    clearAllTabs() {
      this.abasSelecionadas = ["IDENTIFICAÇÃO"];
    },
    verificarAba(aba) {
      if (this.abasSelecionadas && this.abasSelecionadas.length > 0) {
        return this.abasSelecionadas.includes(aba);
      }
    },
    getUsuario() {
      axios
          .get("api/dashboard/usuarios/imprimir/" + this.$route.params.id, {
            params: {
              identificacao: this.identificacao,
              documentos: this.documentos,
              escolaridade: this.escolaridade,
              remuneracao: this.remuneracao,
              aspecto: this.aspecto,
              lazer: this.lazer,
            },
          })
          .then((response) => {
            this.usuario = response.data;
            this.loading = false;
          })
          .catch(() => {
          });
    },

    getAbasFamilias() {
      this.loadingFamilia = true;
      axios
          .post("api/dashboard/print/usuarios/familia/" + this.$route.params.id)
          .then((response) => {
            this.abasfamilia = response.data.data;
          })
          .catch(() => {
            this.loadingFamilia = false;
          })
          .finally(() => {
            this.loadingFamilia = false;
          });
    },
  },
  components: {
    Atividades,
    Atendimentos,
    Encaminhamentos,
    Acompanhamentos,
    AcolhimentoCriancas,
    Medidas,
    Beneficios,
    Violacoes,
    Programas,
    Identificacao,
    Documento,
    Escolaridade,
    Saude,
    Renda,
    SituacaoRua,
    Aspecto,
    Lazer,
    IdentificacaoFamilia,
    ComposicaoFamiliar,
    Habitacao,
    Educacional,
    Financeiro,
    SaudeFamilia,
    CaracteristicaFamilia,
    ConvivenciaFamilia,
    HistoricoScfv,
  },
};
</script>
